import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/styles";
import { Switch, Route, useLocation, useRouteMatch } from "react-router-dom";

import DeliveryTicketsIndex from "./delivery-tickets-index";
import DeliveryTicketsList from "./delivery-tickets-list";
import DeliveryTicketsCreate from "./delivery-tickets-create";

import ViewTitle from "../../common/view-title";
import Loader from "../../common/loader";
import NotFound from "../../common/not-found";

import helpers from "../../utils/helpers";

const useStyles = makeStyles(() => ({
	root: {
		flex: 1,
		display: "flex",
		flexDirection: "column",
	},
}));

export default function DeliveryTickets() {
	const classes = useStyles();
	const { pathname } = useLocation();
	const { path } = useRouteMatch();
	const [state, setState] = useState({
		loading: true,
		permissions: {},
	});

	useEffect(() => {
		const validatePermissions = () => {
			const permissions = helpers.getPermissions(pathname);
			setState((prev) => ({ ...prev, permissions, loading: false }));
		};

		validatePermissions();
	}, []);

	if (state.loading) {
		return <Loader />;
	}

	if (!state.permissions?.read_attr) {
		return <NotFound />;
	}

	return (
		<div className={classes.root}>
			<ViewTitle sedeFlag title="Delivery Tickets" />

			<Switch>
				<Route exact path={path}>
					<DeliveryTicketsIndex permissions={state.permissions} />
				</Route>
				<Route exact strict path={`${path}/list`}>
					<DeliveryTicketsList permissions={state.permissions} />
				</Route>
				<Route exact strict path={`${path}/create`}>
					<DeliveryTicketsCreate permissions={state.permissions} />
				</Route>
				<Route exact strict path={`${path}/:id`}>
					<DeliveryTicketsCreate permissions={state.permissions} />
				</Route>
				<Route path={`${path}/*`}>
					<NotFound />
				</Route>
			</Switch>
		</div>
	);
}
